import React from "react";
import FeatureJobs from "./FeatureJobs";

export default function JobOpening() {
  return (
    <div className="w-full">
      <FeatureJobs />
    </div>
  );
}
